
import { defineComponent } from 'vue';
import BCXMarkdown from '@/components/molecules/BCXMarkdown.vue';
import ByteCookieIcon from '@/components/svg/logo/logo-circles-only.svg?inline';
import Chevron from '@/components/svg-components/Chevron.vue';
import partnerBannerMobile1x from '@/assets/img/partnerpage/insider_banner_mobile_1x.png';
import partnerBannerMobile2x from '@/assets/img/partnerpage/insider_banner_mobile_2x.png';

export default defineComponent({
  name: 'DashboardPartnerProgramCard',
  components: {
    BCXMarkdown,
    ByteCookieIcon,
    Chevron,
  },
  setup() {
    return {
      partnerBannerMobile1x,
      partnerBannerMobile2x,
    };
  },
});
